import { AgencyBasePackage } from '@smg-real-estate/hg-search-libs';

const PRICE_DROP_ALERT_BASE_PACKAGES = [
  AgencyBasePackage.RE_GOLD,
  AgencyBasePackage.RE_SILVER,
  AgencyBasePackage.RE_BRONZE,
  AgencyBasePackage.RE_STARTER,
  AgencyBasePackage.RE_WELCOME,
] as const;

const BACKFILL_LISTER_IDS: readonly string[] = [
  'ffbackfill',
  'anibisfill',
  'tuttifill',
  'h259078',
  'h572221',
];

export const isPriceDropAlertSupportedBasePackage = (
  basePackage?: AgencyBasePackage | null,
): boolean => {
  return !!basePackage && PRICE_DROP_ALERT_BASE_PACKAGES.includes(basePackage);
};

export const isPriceDropAlertSupported = (
  basePackage?: AgencyBasePackage | null,
  subscriptionType?: string | null,
  listerId?: string,
  price?: number | null,
): boolean => {
  const hasSupportedBasePackage = isPriceDropAlertSupportedBasePackage(basePackage);
  const hasReFlexSubscription = basePackage == null && subscriptionType === 'RE Flex';
  const isBackfillLister = BACKFILL_LISTER_IDS.includes(listerId ?? '');
  const hasPositivePrice = (price ?? 0) > 0;

  return (
    hasPositivePrice && !isBackfillLister && (hasSupportedBasePackage || hasReFlexSubscription)
  );
};
